(() => {
  const ready = () => {
    const topButton = document.querySelector('[data-murlto-back-top]');
    if (topButton) {
      const update = () => topButton.classList.toggle('is-visible', window.scrollY > 560);
      window.addEventListener('scroll', update, { passive: true });
      topButton.addEventListener('click', () => window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
      update();
    }
    const loader = document.querySelector('[data-murlto-loader]');
    if (loader) {
      requestAnimationFrame(() => { loader.classList.remove('is-loading'); loader.setAttribute('aria-hidden', 'true'); });
    }
    document.addEventListener('toggle', event => {
      if (!event.target.matches?.('.murlto-mega[open]')) return;
      document.querySelectorAll('.murlto-mega[open]').forEach(item => {
        if (item !== event.target && item.closest('.murlto-mobile-menu') === event.target.closest('.murlto-mobile-menu')) item.open = false;
      });
    }, true);
    document.addEventListener('click', event => {
      if (event.target.closest('.murlto-mega, .murlto-mobile-menu')) return;
      document.querySelectorAll('.murlto-mega[open], .murlto-mobile-menu[open]').forEach(item => { item.open = false; });
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const opened = [...document.querySelectorAll('.murlto-mega[open], .murlto-mobile-menu[open]')];
      opened.forEach(item => { item.open = false; });
      opened.at(-1)?.querySelector('summary')?.focus();
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const homepage = document.body.classList.contains('template-index');
    if (homepage && !reduced.matches && 'IntersectionObserver' in window) {
      const selector = '.murlto-rail__heading-row, .murlto-rail__card, .mulo-real-shop-hero__copy > *, .mulo-real-shop-hero__main-card, .mulo-real-shop-hero__side-card, .murlto-promo__copy > *, .murlto-promo__media';
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -3% 0px' });
      const prepare = scope => {
        const targets = [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
        targets.forEach(target => {
          if (target.classList.contains('murlto-motion-target')) return;
          const siblings = [...target.parentElement.children].filter(node => node.matches(selector));
          const position = Math.min(siblings.indexOf(target), 4);
          target.style.setProperty('--murlto-motion-delay', `${Math.max(0, position) * 75}ms`);
          target.classList.add('murlto-motion-target');
          if (target.getBoundingClientRect().top < window.innerHeight * .8) target.classList.add('is-visible');
          else observer.observe(target);
        });
        document.body.classList.add('murlto-motion-ready');
      };
      prepare(document);
      document.addEventListener('shopify:section:load', event => prepare(event.target));
      reduced.addEventListener?.('change', () => {
        if (!reduced.matches) return;
        document.body.classList.remove('murlto-motion-ready');
        document.querySelectorAll('.murlto-motion-target').forEach(target => target.classList.add('is-visible'));
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
